import { render } from "./InstallerSteps.vue?vue&type=template&id=60276a0f&scoped=true"
import script from "./InstallerSteps.vue?vue&type=script&lang=js"
export * from "./InstallerSteps.vue?vue&type=script&lang=js"

import "./installer-steps.scss?vue&type=style&index=0&id=60276a0f&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\orangehrm-5.8\\installer\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60276a0f"]])

export default __exports__